
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from '@tanstack/react-query';
import { supabase } from "@/integrations/supabase/client";
import { formatPsychologistsData } from "@/utils/scheduleUtils";
import { useRealtimeAllProfilesUpdates } from '@/hooks/useRealtimeProfileUpdates';

export const useScheduleStep1 = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [selectedPsychologistForModal, setSelectedPsychologistForModal] = useState<any>(null);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  const { isConnected } = useRealtimeAllProfilesUpdates();

  const { data: psychologists = [], isLoading, error: queryError } = useQuery({
    queryKey: ['psychologists-directory'],
    queryFn: async () => {
      console.log('PsychologistDirectory - Fetching psychologists from database');
      const { data, error } = await supabase
        .from('psychologists')
        .select('*')
        .eq('is_approved', true)
        .eq('status', 'approved')
        .order('rating', { ascending: false });
      
      if (error) {
        console.error('PsychologistDirectory - Database error:', error);
        throw error;
      }
      
      console.log('PsychologistDirectory - Raw data from database:', data);
      const formattedData = formatPsychologistsData(data || []);
      console.log('PsychologistDirectory - Formatted psychologists:', {
        count: formattedData.length,
        realtimeConnected: isConnected
      });
      return formattedData;
    },
  });

  const handleViewProfile = (psychologistId: string) => {
    console.log('PsychologistDirectory - opening modal for psychologist:', psychologistId);
    const psychologist = psychologists.find(p => p.id === psychologistId);
    if (psychologist) {
      setSelectedPsychologistForModal(psychologist);
      setIsProfileModalOpen(true);
    }
  };

  const handleViewFullProfile = (psychologistId: string) => {
    console.log('PsychologistDirectory - navigating to full profile:', psychologistId);
    navigate(`/psychologist-details/${psychologistId}`);
  };

  const handleScheduleNow = (psychologistId: string) => {
    console.log('PsychologistDirectory - scheduling with psychologist:', psychologistId);
    sessionStorage.setItem('selectedPsychologist', psychologistId);
    navigate(`/schedule/step2?psychologistId=${psychologistId}`);
  };

  const closeModal = () => {
    setIsProfileModalOpen(false);
    setSelectedPsychologistForModal(null);
  };

  return {
    psychologists,
    isLoading,
    queryError,
    selectedPsychologistForModal,
    isProfileModalOpen,
    handleViewProfile,
    handleViewFullProfile,
    handleScheduleNow,
    closeModal,
  };
};
